import { checkIsPlatformAdmin, isFieldStaffUser } from './authRoles';
import { callEdgeFunction } from './supabaseClient';

function rpcOk(data) {
  return data && typeof data === 'object' && data.ok === true;
}

/** staff_directory ile bağlı personel için auth JWT içindeki `role` alanını günceller. */
export async function ensureStaffRoleInJwt(supabase, user) {
  if (!user) return user;
  if (await checkIsPlatformAdmin(supabase, user) || isFieldStaffUser(user)) return user;

  try {
    const data = await callEdgeFunction('sync-staff-role-claim', { method: 'POST' });
    if (!rpcOk(data)) return user;
  } catch {
    return user;
  }

  const { error: refErr } = await supabase.auth.refreshSession();
  if (refErr) return user;

  const { data: gu } = await supabase.auth.getUser();
  return gu?.user ?? user;
}
